<template>
  <div class="landing-page">
    <!-- Header section with black borders -->
    <Header />

    <div class="page-content">
      <div
        class="hero-banner visible-sm-block visible-md-block visible-lg-block"
        style="--hero-background: url('/ivgcs/img/viva-hero-desktop.svg')"
      >
      </div>
      <div
        class="hero-banner visible-xs-block"
        style="--hero-background: url('/ivgcs/img/viva-hero-mobile.svg')"
      >
      </div>
      

      <div id="links" class="container">
        <div id="links-faqs" class="row text-center links-margin">
          <div class="col-xs-12">
            <router-link to="/faqs" class="viva-btn viva-btn-orange btn-wide">
              <strong>FAQs</strong>
            </router-link>
          </div>
        </div>
        <div class="row text-center links-margin">
          <div id="links-viva" class="col-xs-12">
            <div class="links-item">
              <button
                data-cy="forStudents"
                type="button"
                class="viva-btn viva-btn-green btn-wide"
                data-toggle="modal"
                data-target="#signInModal"
              > 
                <strong>For Students</strong>
              </button>
              <p class="text-uppercase links-subtext">
                <strong>
                  wanting to talk about their project
                </strong>
              </p>
            </div>
            <div class="links-item">
              <button
                data-cy="forInstructors"
                type="button"
                class="viva-btn viva-btn-green btn-wide"
                data-toggle="modal"
                data-target="#instructorSignInModal"
              >
                <strong>For Instructors or Administrators</strong>
              </button>
              <p class="text-uppercase links-subtext">
                <strong>
                  wanting to create viva assignments or manage instructors
                </strong>
              </p>
            </div>
          </div>
        </div>
        <div class="row text-center links-margin">
          <div id="inquiry-viva" class="col-xs-12">
            <p class="inquiry-text">VIVA is growing fast. If you are interested in giving it a shot, please join the
              <a
                class="link-accent"
                target="_blank"
                rel="noopener noreferrer"
                href="https://initialview.typeform.com/to/wJ1JVuVs"
              >waitlist</a>!
            </p>
          </div>
        </div>
      </div>
    </div>

    <Footer />

    <div id="signInModal" class="modal fade" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row">
              <div class="col-xs-12">
                <button type="button" class="close" data-dismiss="modal" aria-label="close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 text-center">
                <div class="signin-item">
                  <p class="text-uppercase">
                    <strong>Get started</strong>
                  </p>
                  <router-link
                    data-cy="signin-register"
                    to="/register"
                    class="viva-btn viva-btn-green btn-wide"
                    data-dismiss="modal"
                  >
                    <strong>Create an Account</strong>
                  </router-link>
                </div class="signin-item">
                <div class="signin-item">
                  <p class="text-uppercase">
                    <strong>Already have an account?</strong>
                  </p>
                  <router-link
                    data-cy="signin-login"
                    to="/login"
                    class="viva-btn viva-btn-green btn-wide"
                    data-dismiss="modal"
                  >
                    <strong>Login</strong>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="instructorSignInModal" class="modal fade" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row">
              <div class="col-xs-12">
                <button type="button" class="close" data-dismiss="modal" aria-label="close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 text-center">
                <div class="signin-item">
                  <p class="text-uppercase">
                    <strong>Get started</strong>
                  </p>
                  <router-link
                    data-cy="instructor-signin-register"
                    to="/instructor-register"
                    class="viva-btn viva-btn-green btn-wide"
                    data-dismiss="modal"
                  >
                    <strong>Create an Account</strong>
                  </router-link>
                </div>
                <div class="signin-item">
                  <p class="text-uppercase">
                    <strong>Already have an account?</strong>
                  </p>
                  <router-link
                    data-cy="instructor-signin-login"
                    to="/login"
                    class="viva-btn viva-btn-green btn-wide"
                    data-dismiss="modal"
                  >
                    <strong>Login</strong>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'bootstrap/js/transition';
import 'bootstrap/js/modal';
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import env from '../utils/env';

export default {
  name: 'Landing',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      env: env
    }
  }
}
</script>

<style scoped>
.landing-page {
  background-color: var(--viva-cream);
}

.links-item .viva-btn-green {
  width: 100%;
}

@media (min-width: 768px) {
  .links-item .viva-btn-green {
    white-space: nowrap;
  }
}

.btn-wide {
  padding: 8px 60px;
}

/* Hero Banner */
.hero-banner {
  border-bottom: 2px solid var(--viva-orange);
  width: 100%;
  height: min(75vw, 450px);
  background-image: var(--hero-background);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: auto 120%;
}

/* Links */
.links-subtext {
  margin-top: 10px;
  margin-bottom: 0px;
  width: 0px;
  min-width: 100%;
}

.links-margin {
  margin-top: 48px;
  margin-bottom: 48px;
}

#links-viva {
  display: flex;
  justify-content: center;
  gap: 48px 120px;
}

.links-item {
  width: 480px;
  max-width: 100%;
}

@media (min-width: 768px) {
  /* #links-faqs {
    margin-bottom: 48px;
  } */
}

@media (max-width: 767px) {
  .links-item {
    margin-left: auto;
    margin-right: auto;
  }

  #links-viva {
    flex-direction: column;
  }
}

/* Inquiry Link */
.inquiry-text {
  margin: 0;
}

/* Sign-in Modal */
.modal-dialog {
  margin: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  pointer-events: none;
}

.modal-content {
  margin: 0 auto;
  background-color: var(--viva-cream);
  pointer-events: auto;
}

.signin-item {
  margin-top: 48px;
  margin-bottom: 48px;
}

.faq-section {
  margin-top: 3rem;
  margin-bottom: 3rem;
}

.faq-btn {
  max-width: 200px;
}
</style>